// components/Recommendation/ContributionRecommendation.jsx - DISPLAY BACKEND RESULTS
import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ContributionRecommendation = ({ contributionResult, salary }) => {
    if (!contributionResult) return null;

    const {
        monthly_amount,
        annual_amount,
        tax_relief_amount,
        employer_contribution,
        employer_match_amount,
        net_cost_to_client,
        affordability_percentage,
        contribution_rationale
    } = contributionResult;

    // Handle both employer_contribution and employer_match_amount field names
    const employerAmount = employer_contribution || employer_match_amount || 0;

    return (
        <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
                <Row className="g-4">
                    {/* Monthly Contribution */}
                    <Col md={4}>
                        <div className="text-center p-3 bg-primary bg-opacity-10 rounded-3">
                            <FontAwesomeIcon icon="piggy-bank" className="text-primary mb-2" size="2x" />
                            <h3 className="mb-1 text-primary">
                                £{monthly_amount?.toFixed(0) || 0}
                            </h3>
                            <p className="text-muted mb-0 small">Monthly Contribution</p>
                            {annual_amount && (
                                <p className="text-muted mb-0 small">(£{annual_amount.toFixed(0)}/year)</p>
                            )}
                        </div>
                    </Col>

                    {/* Tax Relief */}
                    <Col md={4}>
                        <div className="text-center p-3 bg-success bg-opacity-10 rounded-3">
                            <FontAwesomeIcon icon="coins" className="text-success mb-2" size="2x" />
                            <h3 className="mb-1 text-success">
                                £{tax_relief_amount?.toFixed(0) || 0}
                            </h3>
                            <p className="text-muted mb-0 small">Annual Tax Relief</p>
                        </div>
                    </Col>

                    {/* Employer Match */}
                    <Col md={4}>
                        <div className="text-center p-3 bg-info bg-opacity-10 rounded-3">
                            <FontAwesomeIcon icon="gift" className="text-info mb-2" size="2x" />
                            <h3 className="mb-1 text-info">
                                £{employerAmount?.toFixed(0) || 0}
                            </h3>
                            <p className="text-muted mb-0 small">Annual Employer Match</p>
                        </div>
                    </Col>
                </Row>

                {/* Affordability Check */}
                {affordability_percentage !== undefined && (
                    <div className="mt-4 p-3 bg-light rounded-3">
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                                icon={affordability_percentage <= 15 ? "check-circle" : "exclamation-triangle"}
                                className={affordability_percentage <= 15 ? "text-success me-2" : "text-warning me-2"}
                            />
                            <div>
                                <strong>Affordability:</strong> {affordability_percentage.toFixed(1)}% of net income
                                {affordability_percentage <= 15 && (
                                    <span className="text-success ms-2">✓ Within Consumer Duty guidelines</span>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Net Cost */}
                {net_cost_to_client && (
                    <div className="mt-3 text-center">
                        <small className="text-muted">
                            Net cost to you after tax relief: <strong>£{net_cost_to_client.toFixed(0)}/year</strong>
                        </small>
                    </div>
                )}

                {/* Rationale */}
                {contribution_rationale && (
                    <div className="mt-4">
                        <h6 className="text-muted mb-2">
                            <FontAwesomeIcon icon="info-circle" className="me-2" />
                            Why This Amount?
                        </h6>
                        <p className="mb-0 text-secondary">{contribution_rationale}</p>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default ContributionRecommendation;